import { render } from "./multilanguage2.vue?vue&type=template&id=3eeda0ef"
import script from "./multilanguage2.vue?vue&type=script&lang=js"
export * from "./multilanguage2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__